export const AI_INTEGRATION_PROVIDER_BEDROCK = "Bedrock";
